export default __webpack_public_path__ + "static/media/Ocean blues 2.68dd4949.jpg";